<pbo-navigation-drawer [attr.data-testid]="testIds.SIDEBAR" [pboLogoUrl]="config.logoUrl" [pboNavItems]="navItems()">
  <div class="main">
    <div class="app-header">
      <pbo-header [attr.data-testid]="testIds.HEADER">
        @if (pageTitleKey(); as key) {
          {{ key | transloco }}
        }
      </pbo-header>
    </div>
    <div class="page">
      <router-outlet />
    </div>
  </div>
</pbo-navigation-drawer>
